<template>
  <footer class="relative bg-blueGray-200 pt-8 pb-6">
    <div
        class="bottom-auto top-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden -mt-20 h-20"
        style="transform: translateZ(0);"
    >
    </div>
    <div class="container mx-auto px-4">
      <div
          class="flex flex-wrap items-center md:justify-between justify-center"
      >
        <div class="w-full md:w-6/12 px-4 mx-auto text-center">
          <div class="text-sm text-blueGray-500 font-semibold py-1 mb-2">
            Copyright © {{ date }}  by Liao Lab <br>

          </div>
          <a class="link" href="https://beian.miit.gov.cn/" target="_blank"
          >粤ICP备2021003175号</a
          >

          <div class="text-sm text-blueGray-500 font-semibold py-1">

          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
import police from "@/assets/img/police.png"
export default {
  data() {
    return {
      date: new Date().getFullYear(),
      police
    };
  },
};
</script>
.link:link {
color: black;
}

.link:visited {
color: black;
}

.link:hover {
color: #e91e63;
}